export const CURRENCY = "EGP";
export const isTouchScreen = () => "ontouchstart" in document.documentElement;
